import {appendQueryString, getRequest} from "@pg-mono/request";
import {apiV2ListLink, Scenario} from "@pg-mono/rp-api-routes";
import {IPaginatedResponse, RegionType} from "@pg-rp/common-types";

import {IRPRequestMeta} from "../../../app/rp_request_meta";

export interface IRegionByCoordinates {
    id: number;
    name: string;
    short_name: string;
    slug: string;
    name_declension_what: string;
    name_declension_where: string;
    type: RegionType;
    parent: {id: number; name: string; slug: string} | null;
}

export const fetchRegionsByCoordinates = (meta: IRPRequestMeta, lat: number, lng: number): Promise<IRegionByCoordinates[]> => {
    const url = appendQueryString(apiV2ListLink.region.list(Scenario.SEARCH_REGION_DETAIL), {lat, lng});

    return getRequest(meta, url).then((response: IPaginatedResponse<IRegionByCoordinates>) => response.results);
};
import {appendQueryString, getRequest} from "@pg-mono/request";
import {apiV2ListLink, Scenario} from "@pg-mono/rp-api-routes";
import {IPaginatedResponse, RegionType} from "@pg-rp/common-types";

import {IRPRequestMeta} from "../../../app/rp_request_meta";

export interface IRegionByCoordinates {
    id: number;
    name: string;
    short_name: string;
    slug: string;
    name_declension_what: string;
    name_declension_where: string;
    type: RegionType;
    parent: {id: number; name: string; slug: string} | null;
}

export const fetchRegionsByCoordinates = (meta: IRPRequestMeta, lat: number, lng: number): Promise<IRegionByCoordinates[]> => {
    const url = appendQueryString(apiV2ListLink.region.list(Scenario.SEARCH_REGION_DETAIL), {lat, lng});

    return getRequest(meta, url).then((response: IPaginatedResponse<IRegionByCoordinates>) => response.results);
};
